

























import { Component, Vue } from "vue-property-decorator"
import { Howl } from "howler"

@Component
export default class FirstLoad extends Vue {
  // Decorators: https://github.com/kaorun343/vue-property-decorator
  // Class: https://github.com/vuejs/vue-class-component
  protected dismiss() {
    if (!this.$store.state.muted) {
      new Howl({
        src: ["/audio/Notification.mp3"]
      }).play()
    }
    this.$store.dispatch("instructionsOver")
  }

  protected tutorial() {
    if (!this.$store.state.muted) {
      new Howl({
        src: ["/audio/Notification.mp3"]
      }).play()
    }
    this.$store.dispatch("instructionsOver")
    this.$store.dispatch("beginTutorial")
  }
}
